import { styled } from '@mui/material';
import { Menu as UIMenu } from '@o2/ui';

const Menu = styled(UIMenu, {
  name: 'AppBarInternal',
  slot: 'Menu',
})(() => ({
  marginTop: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
}));

Menu.displayName = 'AppBarInternal.Menu';

export default Menu;
